import { createContext, useContext } from "react";

export type OptionsModalConfig = {
  id: string;
  isopen: boolean;
  isEditing: boolean; 
  isConfiguration: boolean;
  isCreating: boolean;
  width: string;
}

export const ModalCalendarContext = createContext<{ options: OptionsModalConfig; setOptions: React.Dispatch<React.SetStateAction<OptionsModalConfig>> } | undefined>(undefined);

export const useModalCalendar = () => {
  const context = useContext(ModalCalendarContext);
  if (!context) {
    throw new Error('useModalCalendar must be used within a ModalCalendarContext.provider');
  }
  return context;
};